import React from 'react'
import { useState } from 'react';
import { graphql, useStaticQuery } from "gatsby"

export const query = graphql`
  {
    bd: allBdmensualCsv(
        sort: {fields: Entidad}
    ) {
      Entidades: distinct(field: Entidad)
    }
  }
`


const CmpEntidadesList = (props) => {
    const { value , onChangeValue, removeNacional } = props;

    let includeNacional = (typeof removeNacional == 'undefined' || removeNacional==false );
    const rs = useStaticQuery(query)        
    const { bd: data} = rs
    // const [selected, setSelected] =  useState(includeNacional ? "Nacional" : "Aguascalientes");    
    const [selected, setSelected] =  useState((value!='' && value!='Nacional') ? value : includeNacional ? "Nacional" : "Aguascalientes");

    // reorder "nacional" entry to the top, if exists
    let items = [...data['Entidades']];
    if(data['Entidades'].map(e => e.toLowerCase()).includes('nacional')) {
      // data['Entidades'] = (data['Entidades'].filter(e => e.toLowerCase()!='nacional'));
      items = (data['Entidades'].filter(e => e.toLowerCase()!='nacional'));
      if(includeNacional) items.unshift('Nacional')
    }    

    function handleClick(val, e) {            
      setSelected(val)
      onChangeValue(val)        
      e.preventDefault();
    }        
    
    return(
        <div>
            <ul>
                {items.map((item) => {
                return <li key={`${item}`} className={`entidad ${item==selected ? "selected" : ""}`}>
                  <i className="icon bx-map"></i>
                  <a href="#!"  onClick={(e) => handleClick(`${item}`, e)}>{item}</a>
                  </li>
                })}
            </ul>
        </div>
    )

}

export default CmpEntidadesList